import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_f35p3h99cn: FaireCollectionEntity = {
  token: "pbc_f35p3h99cn",
  type: "collection",
  name: "MOST LOVED",
  heroImageUrl:
    "https://cdn.faire.com/fastly/859bcf763835fbe2c287ab40c79fd17e26ee0c8e595dd8adfaaa2df4c6f94465.jpeg",
  itemCount: 21,
  brandToken: "b_q8gu9by5sv",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:48:54.930Z",
    importedBy: "entity-db-import-collections",
  },
};
